import React from "react";
import { ReactComponent as Icon } from "./wb_sunny-white-18dp.svg";

const SunIcon = () => {
  return (
    <>
      <Icon style={{ width: "36px", height: "36px" }} />
    </>
  );
};

export default SunIcon;
